import PropTypes from 'prop-types';
import React from 'react';

import ClassCardFlip from '../ClassCard/ClassCardFlip';
import Config from '../../../config';
import { mobileDetect } from '../../../utils/browser';
import { translateLocal } from '../../../i18n';

import './FeaturedClass.scss';

const { isDesktop } = mobileDetect();

const FeaturedClass = ({ item }) => (
  <div className="featured-class">
    <ClassCardFlip
      image={{ src: item.heroImage.childImageSharp.fluid, alt: translateLocal(item.image.alt) }}
      title={translateLocal(item.title)}
      name={item.name}
      domain={translateLocal(item.domain)}
      teaches={translateLocal(item.teaches)}
      description={translateLocal(item.description)}
      animated
      zoomable={false}
      flip={!isDesktop()}
      link={`${Config.routePaths.classes}/${item.id}`}
      preSale={item.isPreSale}
      preSaleLabel={item.preSaleLabel}
    />
  </div>
);

FeaturedClass.propTypes = {
  item: PropTypes.object.isRequired,
};

export default FeaturedClass;
